/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AgentHomePage from "./AgentHomePage";
import SpanishHomePage from "./components/SpanishPage/SpanishHomePage";
// import MetaTags from "./components/MetaTags"; 
import { CookieSetting } from "cookiesetting-component";
function App() {
  return (
    <React.Fragment>
      {/* <MetaTags /> */}
      <Routes>

      <Route path="*" element={<SpanishHomePage />} />
      <Route path="/*" element={<SpanishHomePage />} />

        {/* Redirect from root path to /es */}
        <Route path="/" element={<Navigate to="/es" />} />

        {/* Route for Spanish Home Page */}
        <Route path="/es" element={<SpanishHomePage />} />

        {/* Route for English Home Page */}
        <Route path="/en" element={<AgentHomePage />} />

        {/* Add any additional routes here */}
      </Routes>
      <CookieSetting 
     privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
     configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
     analytics={process.env.REACT_APP_ANALYTICS_PATH}
   />
    </React.Fragment>
  );
}

export default App;
